import React, { Component } from 'react';
import UploadButton from './UploadButton';
import PredefinedImage from './PredefinedImage';
import { applicationModes } from '../constants';

let modeDescriptors = {
  default: {
    title: 'Cloudinary in Action',
    description: 'With Cloudinary, you can easily develop and deliver image-rich responsive websites for any device. Experience image upload directly from the browser, powerful image manipulations on-the-fly and more.',
    predefinedImages: [
      { public_id: 'woman', bytes: 330400, width: 2400, height: 1600, format: 'jpg', original_filename: 'woman' },
      { public_id: 'friends', bytes: 2088543, width: 3000, height: 2001, format: 'jpg', original_filename: 'friends' },
      { public_id: 'sofa_cat', bytes: 1566087, width: 3940, height: 2543, format: 'jpg', original_filename: 'sofa_cat' },
      { public_id: 'car_lady_dog', bytes: 2068742, width: 3940, height: 3056, format: 'jpg', original_filename: 'car_lady_dog' },
      { public_id: 'balloons', bytes: 1090556, width: 2509, height: 1673, format: 'jpg', original_filename: 'balloons' }
    ],
    supportsUpload: true,
    metaTitle: 'Cloudinary Demo',
    metaDescription: 'With Cloudinary, you can easily develop and deliver image-rich responsive websites for any device. Experience image upload directly from the browser, powerful image manipulations on-the-fly and more.'
  },
  qa: {
    title: 'Content-aware encoding',
    metaTitle: 'Content-aware encoding',
    description: 'With Cloudinary, you can easily deliver your images in optimal quality. See how the compression level and encoding settings are optimized based on the image content and the user\'s browser.',
    supportsUpload: true
  },
  ga: {
    title: 'Content-aware cropping',
    metaTitle: 'Content-aware cropping',
    description: 'With Cloudinary, you can easily deliver images to perfectly fit your graphic design and layout, on any device. See how images are intelligently cropped on-the-fly based on auto-detected regions of interest.',
    supportsUpload: true
  },
  'multi-cdn': {
    title: 'Multi-CDN Delivery Demo',
    metaTitle: 'Multi-CDN Delivery',
    description: 'Transparently and automatically selects the best features from multiple CDNs to speed up and enhance delivery of content to end users',
    supportsUpload: false
  }
};

const updateMeta = function(desc) {
  // Update title and meta
  document.title = desc.metaTitle || 'Cloudinary Demo';
  const metaDescriptionElement = document.querySelector('meta[name="description"]');
  if (metaDescriptionElement) {
    metaDescriptionElement.setAttribute('content', desc.metaDescription);
  } else {
    // Add meta description tag
    const metaElem = document.createElement('meta');
    metaElem.name = 'description';
    metaElem.content = desc.metaDescription;
    document.getElementsByTagName('head')[0].appendChild(metaElem);
  }
};

export default class UploadPanel extends Component {

  componentDidMount() {
    const desc = modeDescriptors[this.props.applicationMode] || modeDescriptors[applicationModes.DEFAULT];
    updateMeta(desc);
  }

  componentDidUpdate() {
    const desc = modeDescriptors[this.props.applicationMode] || modeDescriptors[applicationModes.DEFAULT];
    updateMeta(desc);
  }

  render() {
    let desc = modeDescriptors[this.props.applicationMode] || modeDescriptors[applicationModes.DEFAULT];
    let predefinedImages = desc.predefinedImages || modeDescriptors[applicationModes.DEFAULT].predefinedImages;
    let supportsUpload = desc.supportsUpload; // Denotes whether the feature allows uploading user content

    return (
      <div className={this.props.applicationMode + ' panel-upload text-center'} >
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
              <h1 className="text-uppercase">{desc.title}</h1>
              <p>
                {desc.description}
              </p>
              {supportsUpload ? (<UploadButton onResult={this.props.setCurrentImage} />) : false}
            </div>
          </div>
          <span className="title">{supportsUpload ? 'Or select one of the images below:' : 'Select one of the images below to see multi-CDN results:'}</span>
          <ul className="list-inline list-img">
            {predefinedImages.map(i => <PredefinedImage {...this.props} key={i.public_id} resourceInfo={i} onSelect={this.props.setCurrentImage} />)}
          </ul>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/UploadPanel.js
 **/